
    import __i18nConfig from '@next-translate-root/i18n.js'
    import __appWithI18n from 'next-translate/appWithI18n'
    import { useEffect } from 'react';
import type { AppProps, NextWebVitalsMetric } from 'next/app';
import Head from 'next/head';
import { FontGlobals } from '@lib/fonts';
import { GoogleAnalytics } from '@next/third-parties/google';
import { GA_TRACKING_ID, captureAttribution, reportWebVitalsToGA } from '@lib/utilities/analytics';
import LazyGtm from '@components/utils/lazy-gtm';
import '../styles/globals.css';
/**
 * Deliberately thin. Each concern lives in exactly one module:
 *
 *   fonts     → @lib/fonts            (<FontGlobals/> + the next/font faces)
 *   analytics → @lib/utilities/analytics (event helpers; the one JSX line —
 *               the GoogleAnalytics gate — renders below, as in sweetandbitter)
 *   consent   → @lib/consent          (bootstrap injected by _document; the
 *                                      cookie banner upgrades from there)
 *
 * Order matters once: _document's inline consent bootstrap runs before
 * GoogleAnalytics loads gtag.js — the Consent Mode v2 contract (D22).
 */
export function reportWebVitals(metric: NextWebVitalsMetric) {
    reportWebVitalsToGA(metric);
}
function AVApp({ Component, pageProps }: AppProps) {
    // first-touch attribution for the anonymous conversion counter — must run
    // on the LANDING page, before SPA navigation discards referrer/utm params
    useEffect(() => { captureAttribution(); }, []);
    return (<>
      <Head>
        {/* Next's pages-router default is width=device-width WITHOUT
            initial-scale=1. Android WebViews (Viber/Instagram in-app
            browsers) then zoom-fit to document.scrollWidth if ANY element
            leaks past the right edge — the whole site renders at ~97% with a
            white gutter (owner screenshot, 2026-09-17). initial-scale=1 pins
            the layout viewport to the device width; html{overflow-x:clip}
            in globals.css absorbs any residual bleed. */}
        <meta name="viewport" content="width=device-width, initial-scale=1"/>
      </Head>
      <FontGlobals />
      <Component {...pageProps}/>
      {GA_TRACKING_ID ? <GoogleAnalytics gaId={GA_TRACKING_ID}/> : null}
      <LazyGtm />
    </>);
}
const __Next_Translate__Page__1a0b0b8f7e3__ = AVApp;

    export default __appWithI18n(__Next_Translate__Page__1a0b0b8f7e3__, {
      ...__i18nConfig,
      isLoader: true,
      skipInitialProps: true,
      loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || (() => Promise.resolve({})),
    });
  